import $ from 'jquery';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import ReactGA from 'react-ga4';
import ZoneHistoryCalendar from '../components/zone-history/ZoneHistoryCalendar';
import ZoneHistoryCarousel from '../components/zone-history/ZoneHistoryCarousel';
import ZoneHistoryDatePicker from '../components/zone-history/ZoneHistoryDatePicker';
import SessionManager from '../routes/SessionManager';
import Loading from '../components/Loading';
import CommonUtils from '../util/CommonUtils';
import API from '../service/SiteKickAPIService';

function ZoneHistory() {
    var sessionMgr = new SessionManager();
    let user = sessionMgr.readCookie('user');

    const [loading, setLoading] = useState(true);
    const [current_date, setCurrentDate] = useState(null);
    const [start_date, setStartDate] = useState(moment(new Date()).add(-6, 'days').format('YYYY-MM-DD'));
    const [end_date, setEndDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const [max_date, setMaxDate] = useState(moment(new Date()));
    const [min_date, setMinDate] = useState(moment(new Date()).add(-6, 'days'));

    let sitePlanRef = new URL(window.location).searchParams.get('siteplan-ref');
    let ai_event_date = user.ai_event ? user.ai_event.sec_timestamp * 1000 : null;

    if (sitePlanRef) {
        for (let zone of user.zones) {
            if (zone.location_id === sitePlanRef + "") {
                user.zone_selected = zone;
                sessionMgr.storeCookie('user', user); //Update user cookie.
            }
        }
    }

    // If zone_selected is missing but ai_event has location_id, derive zone_selected from the event
    if (!user.zone_selected && user.ai_event && user.ai_event.location_id) {
        let zoneFromEvent = user.zones && user.zones.find(z => z.location_id === user.ai_event.location_id);
        if (zoneFromEvent) {
            user.zone_selected = zoneFromEvent;
            sessionMgr.storeCookie('user', user);
        }
    }

    let location_lastupdate = user.zone_selected ? user.zone_selected.location_lastupdate : null;
    if (location_lastupdate === undefined || location_lastupdate === null || String(location_lastupdate) === "0")
        location_lastupdate = null;

    let timezone = user.site_selected.site_iana_timezone;
    if (!timezone)
        timezone = moment.tz.guess();

    //date is always end date.
    useEffect(() => {
        if (!ai_event_date && !location_lastupdate) {
            fetchZoneHistoryDateRange(location_lastupdate);
        } else {
            fetchZoneHistoryDateRange((ai_event_date || location_lastupdate));
            let currentMoment = moment.tz((ai_event_date || location_lastupdate), timezone);
            let currentDate = currentMoment.format('YYYY-MM-DD');
            setCurrentDate(currentDate);

            let withinRange = current_date >= start_date && current_date <= end_date;
            if (!withinRange) {

                let end_date = currentMoment.format('YYYY-MM-DD');
                let start_date = currentMoment.add(-6, 'days').format('YYYY-MM-DD');
                setEndDate(end_date);
                setStartDate(start_date);
            }
        }
        $('#daily_report').attr('href', '/api/reports/pdf-export/daily-report/' + user.site_selected.site_id);
    }, []);

    const fetchZoneHistoryDateRange = (location_lastupdate) => {
        const location_id = (user.zone_selected && user.zone_selected.location_id)
            || (user.ai_event && user.ai_event.location_id);

        if (!location_id) {
            setLoading(false);
            return;
        }

        let data = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            form_input: {
                "query": JSON.stringify({
                    attributes: ['max(sec_timestamp) as max_date, min(sec_timestamp) min_date'],
                    object: 'image_history',
                    filters: [
                        { operator: '=', attribute: "location_id", value: location_id },
                        { join_by: 'and', operator: '!=', attribute: 'sec_timestamp', value: 0 }
                    ],
                    sort_by: [{ attribute: 'sec_timestamp', value: 'desc' }],
                    pagination: { page: 1, size: 1 }
                })
            }
        };

        CommonUtils.ajax(
            {
                url: API.DATA.EXPLORER,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200 && res.data) {
                    if (res.data && res.data.length > 0) {
                        let maxDate = moment.tz(res.data[0]['max_date'] * 1000, timezone);
                        let minDate = moment.tz(res.data[0]['min_date'] * 1000, timezone);
                        let endDate = moment.tz(res.data[0]['max_date'] * 1000, timezone);
                        let hwindow = { max_date: maxDate, min_date: minDate, loading: false };
                        if (!location_lastupdate) {
                            hwindow = { ...hwindow, current_date: endDate.format('YYYY-MM-DD'), end_date: endDate.format('YYYY-MM-DD'), start_date: endDate.add(-6, 'days').format('YYYY-MM-DD') };
                            setLoading(hwindow.loading);
                            setMaxDate(hwindow.max_date);
                            setMinDate(hwindow.min_date);
                            setCurrentDate(hwindow.current_date);
                            setStartDate(hwindow.start_date);
                            setEndDate(hwindow.end_date);
                        }
                        setLoading(hwindow.loading);
                        setMaxDate(hwindow.max_date);
                        setMinDate(hwindow.min_date);
                    }
                } else {
                    setLoading(false);
                }
            }
        )
    }

    // console.log('Location Last Update: ', moment.tz(location_lastupdate, timezone).format('MMM DD, YYYY HH:mm'));
    // console.log('Location Now: ' + moment().tz(timezone).format('MMM DD, YYYY HH:mm'));

    const onZoneDateCalendarClick = (zone_date_rec) => {
        setCurrentDate(moment(zone_date_rec.dev_timestamp * 1000).tz(timezone).format('YYYY-MM-DD'));
        ReactGA.event({
            category: 'Navigation',
            action: 'Clicked ZoneDate',
            label: 'Click Zone Date Calendar '
        });
    }

    const setZoneHistoryRange = (obj) => {
        setEndDate(obj.end_date);
        setStartDate(obj.start_date);
        setCurrentDate(obj.end_date);
    }

    if (!user.zone_selected) {
        return <Loading>Loading ...</Loading>;
    }

    return (
        <React.Fragment>
            <div className="page-container">
                {!loading ? <>
                    <div className="row">
                        <div className="col-md-6 pt-3 pl-0 text-primary font-weight-bold">
                            {user.zone_selected.location_name}
                        </div>
                        <div className="col-md-6 p-1">
                            <ZoneHistoryDatePicker date_range={[min_date, max_date]} date={start_date} end_date={end_date} onSubmit={setZoneHistoryRange} />
                        </div>
                    </div>
                    <div className="row mt-2 p-md-0 p-2">
                        <div className="col-md-9 bg-white border-rounded-l order-md-1 order-2">
                            <ZoneHistoryCarousel date={current_date}></ZoneHistoryCarousel>
                        </div>
                        <div className="col-md-3 bg-gray order-md-2 order-1 bg-light border-rounded-r">
                            <ZoneHistoryCalendar date={start_date} end_date={end_date} onZoneDateClick={onZoneDateCalendarClick} />
                        </div>
                    </div>
                </> :
                    <Loading>Loading ...</Loading>}
            </div>
            <br />
        </React.Fragment>
    );
}

export default ZoneHistory;